<template>
  <header :class="navClass">
    <router-link class="public-nav-brand" to="/" aria-label="Hilarity Unlimited home">
      <img :src="logoSrc" alt="" width="56" height="56" />
      <span>Hilarity Unlimited</span>
    </router-link>
    <nav class="public-nav-links" aria-label="Site">
      <router-link
        v-for="link in links"
        :key="link.to"
        :to="link.to"
      >
        {{ link.label }}
      </router-link>
    </nav>
  </header>
</template>

<script>
/** @see docs/APP_UI_SPEC.md — G1 */
import logoSrc from '../assets/HilarityUnlimited-Logo.png';
import { PUBLIC_NAV_LINKS, publicNavClassForPath } from '../utils/publicSite.js';

export default {
  name: 'PublicSiteNav',
  data() {
    return { logoSrc, links: PUBLIC_NAV_LINKS };
  },
  computed: {
    navClass() {
      return publicNavClassForPath(this.$route.path);
    },
  },
};
</script>

<style scoped>
.public-nav {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px 20px;
  box-sizing: border-box;
  width: 100%;
  padding: 12px 20px;
  background: #0b0b0c;
  text-align: left;
}
.public-nav-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #f4efe4;
  text-decoration: none;
  font-weight: 700;
  letter-spacing: 0.02em;
}
.public-nav-brand img {
  display: block;
  border-radius: 4px;
}
.public-nav-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
}
.public-nav-links a {
  color: #d9d0c4;
  text-decoration: none;
  font-size: 0.95rem;
}
.public-nav-links a.router-link-exact-active {
  color: #f0c14b;
}
.public-nav--apply {
  background: rgba(255, 255, 255, 0.14);
  border-bottom: 1px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}
.public-nav--apply .public-nav-brand {
  color: #fff;
}
.public-nav--apply .public-nav-links a {
  color: rgba(255, 255, 255, 0.92);
}
.public-nav--apply .public-nav-links a.router-link-exact-active {
  color: #f0c14b;
}
</style>
